const log = {

    v(message, object) {
        this.log('v', message, object);
    },
    s(message, object) {
        this.log('s', message, object);
    },
    w(message, object) {
        this.log('w', message, object);
    },
    e(message, object) {
        this.log('e', message, object);
    },

    log(type, message, object) {
        if (type.length > 1) {
            if (message) {
                console.log(type, message);
            }else {
                console.log(type);
            }
            return;
        }
        if (object) {
            switch (type) {
                case 'v': console.log('%c' + message, 'color: #24A4F2', object); break;
                case 's': console.log('%c' + message, 'color: #8DEE57', object); break;
                case 'w': console.log('%c' + message, 'color: #EED757', object); break;
                case 'e': console.log('%c' + message, 'color: #E36B6B', object); break;
                default: console.log(message, object);
            }
        }else {
            switch (type) {
                case 'v': console.log('%c' + message, 'color: #24A4F2'); break;
                case 's': console.log('%c' + message, 'color: #8DEE57'); break;
                case 'w': console.log('%c' + message, 'color: #EED757'); break;
                case 'e': console.log('%c' + message, 'color: #E36B6B'); break;
                default: console.log(message);
            }
        }
    },

};
export default log;